import { ellipsis } from "polished";
import styled, { css } from "styled-components";

const breakpoints = {
  small: "576px",
  medium: "767px",
  large: "992px",
  xlarge: "1200px",
};

const media = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakpoints[label]}) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

export const Body = styled.div`
  width: 100%;
  background-color: #ffff;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  overflow-y: hidden;
  ${media.medium`
  width: 100%;
  padding-left: 10px;
  `}
    ${({ isFromApp }) =>
    isFromApp &&
    `
      padding-left: 0px;
    `}
`;
export const ImageContainber = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SchoolImage = styled.img`
  width: 100%;
  height: 100%;
  position: relative;
  border-top-right-radius: 5%;
  border-bottom-right-radius: 5%;
  object-fit: cover;
  object-position: center;
`;
export const DefaultImg = styled.div`
  background-color: #2555ef;
  width: 100%;
  height: 100%;
  border-top-right-radius: 5%;
  border-bottom-right-radius: 13%;
  svg {
    padding-left: 20%;
    margin-left: 4%;
    fill: #2555ef;
    filter: drop-shadow(7px 4px 78px rgba(44, 52, 104, 0.16));
    border-bottom-right-radius: 5%;
  }
`;
export const LogoImage = styled.img`
  position: absolute;
  top: 32px;
  left: 53px;
  z-index: 5;
  width: 10%;
  background-color: #ffff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
`;
export const Content = styled.div`
  position: absolute;
  top: 75%;
  left: 4%;
  width: fit-content;
  line-break: auto;
`;
export const Title = styled.h1`
  font-style: normal;
  font-weight: var(--general-display-font-weight);
  font-size: var(--general-display-font-size);
  line-height: 39px;
  color: var(--font-color-white);
`;
// export const Description = styled.p`
// width: 660.18px;
// font-style: normal;
// line-height: 26px;
// text-transform: capitalize;
// max-width: 80%;
// max-height: 50px;
// overflow-y:scroll;
// `
export const AboutUs = styled.button`
  color: var(--font-color-blue2555ef);
  border-radius: 5px;
  background: var(--white, #fff);
  border: none;
  display: flex;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: var(--general-label-font-size);
  font-weight: var(--general-label-font-weight);
  line-height: 32px;
`;

// First Page Right Side
export const RightSideWrappr = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  @media only screen and (max-width: 1920px) and (max-height: 1080px) {
    margin: 31px 40px;
    width: 40%;
  }
  @media only screen and (min-width: 1921px) {
    margin-left: 40px;
  }
  ${media.medium`
    margin: 20px 16px;
    width: 100%;
    padding-right: 0;
  `}


  width: 45%;
  margin-top: 77px;

     ${({ isFromApp }) =>
    isFromApp &&
    `
      margin: 35px 0px !important;
      padding: 0px !important;
    `}
`;
export const RightSideContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-right: 50px;
  flex: 1;
  min-height: 0;
  padding-left: 10px;

  ${media.medium`
    padding-right: 10px;
  `}

`;
export const LeftSideWrapper = styled.div`
  flex: 1;
  width: 60%;
  ${media.medium`
    width: 0%;
    display: none;
  `}

`;

export const Spinner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const EventType = styled.div`
  width: 100%;
  height: ${({ isMultiDate }) => (isMultiDate ? "auto" : "123px")};
  min-height: 123px;
  flex-shrink: 0;
  border-radius: 4px;
  background: rgba(37, 85, 239, 0.04);
  padding-top: 23px;
  padding-bottom: 23px;
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: 16px;
  overflow: hidden;
  ${media.medium`
  height:auto;
  flex-direction: column;
  `}
`;
export const EventTypeName = styled.div`
  width: 166px;
  height: 77px;
  flex-shrink: 0;
  padding-left: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: var(--font-color-blue007bff);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: var(--general-page-header-font-family);
  font-size: var(--general-page-header-font-size);
  font-style: normal;
  font-weight: var(--general-page-header-font-weight);
  line-height: 32px; /* 123.077% */
  text-transform: capitalize;
  border-right: 1px solid rgba(0, 46, 92, 0.05);
  ${media.medium`
  border-bottom: 1px solid rgba(0, 46, 92, 0.05);
  width: 100%;
  border-right:0;
  margin-left: -19px;
  `}
  
  span {
    color: var(--font-color-blue002e5c);
    font-size: var(--general-caption-font-size);
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
  }
`;
export const EventTypeDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  padding-left: 20px;
  padding-right: 20px;
  text-align: left;
  font-weight: var(--general-body-font-weight);
  font-size: var(--general-body-font-size);

  ${media.medium`
  padding-left: 12px;
  padding-right: 12px;
  `}
  p{
    word-wrap: break-word;
    width: 97%;

  }
  > div {
    flex-direction: row;
  }
  span {
    color: var(--font-color-blue002e5c);
    font-family: var(--general-caption-font-family);
    font-size: var(--general-caption-font-size);
    font-style: normal;
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
    text-transform: capitalize;
    opacity: 0.7;
  }
`;

export const EventTitle = styled.div`
  text-align: center;
`;
export const EventName = styled.h1`
  font-style: normal;
  font-weight: var(--general-page-header-font-weight);
  font-size: var(--general-page-header-font-size);
  line-height: 29px;
  color: var(--font-color-blue002e5c);
`;
export const ClassInformation = styled.h1`
  font-style: normal;
  font-weight: var(--general-header-font-weight);
  font-size: var(--general-header-font-size);
  line-height: 24px;
  color: var(--font-color-blue002e5c);
  text-align: left;
  margin-bottom: 42px;
`;

export const EventCaption = styled.p`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: var(--general-large-body-font-family);
  font-style: normal;
  font-weight: var(--general-large-body-font-weight);
  font-size: var(--general-large-body-font-size);
  /* line-height: 40px; */
  text-transform: capitalize;
  color: var(--font-color-blue002e5c);
  div {
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 3px 10px;
    gap: 5px;
    font-size: var(--general-small-label-font-size);
    font-weight: var(--font-weight-bold);
    background: rgba(250, 51, 114, 0.1);
    border-radius: 6px;
    margin-left: 8px;
    color: var(--font-color-redfa3372);
    white-space: nowrap;
    letter-spacing: 0.01em;

  }
`;
export const Description = styled.div`
  flex: 1;
  span {
    color: var(--font-color-blue002e5c);
    opacity: 0.7;
    font-size: var(--general-caption-font-size);
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
  }
  p {
    color: var(--font-color-blue002e5c);
    font-size: var(--general-large-body-font-size);
    font-weight: var(--general-large-body-font-weight);
    line-height: normal;
    font-feature-settings: "clig" off, "liga" off;
    font-family: var(--general-large-body-font-family);
  }
`;
export const DescriptionText = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  font-size: var(--general-small-header-font-size);
  font-weight: var(--general-small-header-font-weight);
  margin-top: 13px;
  ${({ showMore }) => showMore && ellipsis(undefined, 3)}
`;

export const ShowMoreText = styled.div`
  cursor: pointer;
  font-size: var(--general-small-header-font-size);
  /* margin-top: 20px; */
  margin-bottom: 30px;
  font-weight: var(--general-small-header-font-weight);
`;
export const ContactTitle = styled.div`
  font-size: var(--general-small-label-font-size);
  opacity: 0.7;
  color: var(--font-color-blue002e5c);
  padding-bottom: 5px;
`;
export const ContactInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-weight: var(--general-body-font-weight);
  font-size: var(--general-body-font-size);
  margin-bottom: 20px;

  span {
    color: var(--font-color-blue002e5c);
    font-family: var(--general-caption-font-family);
    font-size: var(--general-caption-font-size);
    font-style: normal;
    font-weight: var(--general-caption-font-weight);
    line-height: normal;
    text-transform: capitalize;
    opacity: 0.7;
  }
`;
export const ContactInfoDetails =styled.div`
     display: flex;
    align-items: baseline;
    flex-direction: row;
    width: 71%;
    ${media.medium`
    flex-direction:column ;
    `}


`
export const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: space-between;
  width: 100px;
  margin-top: -35px;
`;
export const DashLine = styled.hr`
  border-top: dashed 2px #002e5c;
  opacity: 0.2;
  width: 100%;
`;
export const PayDetails = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  color: var(--font-color-blue002e5c);

  li {
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: var(--general-body-font-weight);
    font-size: var(--general-body-font-size);
    line-height: 21px;
    text-transform: capitalize;
  }
  span {
    display: flex;
    justify-content: space-between;
    font-style: normal;
    font-weight: var(--general-body-font-weight);
    font-size: var(--general-body-font-size);
    line-height: 21px;
    span {
      color: var(--font-color-blue002e5c);
      text-align: right;
      font-family: var(--general-small-header-font-family);
      font-size: var(--general-small-header-font-size);
      font-style: normal;
      font-weight: var(--general-small-header-font-weight);
      line-height: normal;
      text-transform: capitalize;
    }
  }
`;
export const TotalPay = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: var(--font-weight-regular);
  font-size: var(--general-amount-font-size);
  line-height: 21px;
  span {
    color: var(--font-color-blue002e5c);
    text-align: right;
    font-weight: var(--font-weight-bold);
    line-height: normal;
    text-transform: capitalize;
  }
`;
export const CounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media only screen and (max-width: 420px) {
    width: 100%;
  }
 
`;
export const CounterDetails = styled.div`
  

`

export const FixedBottomSection = styled.div`
  flex-shrink: 0;
  padding: 12px 50px 0px 10px;
  ${media.medium`
    padding: 12px 10px 0px 10px;
  `}
`;

export const ReserveAction = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 50px;
  padding-top: 10px;
  gap: 15px;
  ${media.medium`
      margin-right: 10px;
        ${({ isFromApp }) =>
      isFromApp &&
      `
        margin-left: 10px;
      `}
  `}

  @media only screen and (max-width: 420px) {
    flex-direction: column;
  }
`;

export const ReserveButton = styled.button`
  display: flex;
  height: 48px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background:${(props) => (props.disabledButton ? '#F0F0F3' : '#2555EF')};
  color: ${(props) => (props.disabledButton ? '#B5B5C3' : 'var(--White-100, #fff)')};
  cursor: ${(props) => (props.disabledButton ? 'not-allowed !important' : 'pointer')};
  font-feature-settings: "clig" off, "liga" off;
  /* Small Medium 13 */
  font-family: var(--general-button-font-family);
  font-size: var(--general-button-font-size);
  font-style: normal;
  font-weight: var(--general-button-font-weight);
  line-height: 32px; /* 246.154% */
  text-transform: capitalize;
  border: 0;
  /* margin-top: 5%; */
  ${media.medium`
  height: 42px;

  `
}

  @media only screen and (max-width: 420px) {
    width: 100%;
  }
`;


export const EventLogin = styled.div`
 display: flex;
 justify-content: flex-end;
`;

export const ReserveLoginButton = styled.button`
  background: transparent !important;
  color: var(--font-color-blue2555ef);
  border: none;
  font-weight: var(--general-button-font-weight);
  font-size: var(--general-button-font-size);
  line-height: 21px;
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
`;

export const Note = styled.div`
      opacity: 0.7;
    color: var(--font-color-blue002e5c);

`

export const TicketContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
  ${media.medium`
  `}
`;
export const MultiDatesWrapper = styled.div`
  display: flex;
  flex-direction: column !important;
  gap: 5px;
  width: 100%;
`;

export const DatesRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  width: 100%;
`;

export const DateChip = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 10px;
  background: rgba(37, 85, 239, 0.07);
  border-radius: 8px;
  width: fit-content;
  box-sizing: border-box;

  .chip-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    font-size: var(--general-badge-font-size);
    font-weight: var(--general-badge-font-weight);
    color: var(--font-color-blue002e5c);
    opacity: 1;
    white-space: nowrap;
    text-transform: none;
  }

  .chip-icon {
    width: 11px;
    height: 11px;
    opacity: 0.6;
    flex-shrink: 0;
  }
`;

export const MoreDatesChip = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 12px;
  background: rgba(37, 85, 239, 0.12);
  border-radius: 20px;
  width: fit-content;
  font-size: var(--general-badge-font-size);
  font-weight: var(--general-badge-font-weight);
  color: var(--font-color-blue2555ef);
  cursor: pointer;
  margin-top: 2px;

  &:hover {
    background: rgba(37, 85, 239, 0.18);
  }
`;

export const TicketsCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const TicketsCardsTitle = styled.h2`
    font-style: normal;
    font-weight: var(--general-header-font-weight);
    font-size: var(--general-header-font-size);
    line-height: 29px;
    color: var(--font-color-gray212529);
    text-transform: capitalize;
`;
export const TicketsCardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 186px;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: rgba(37, 85, 239, 0.25) transparent;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(37, 85, 239, 0.25);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;
export const TicketsCardContainer = styled.div`
  padding: 10px;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  ${({isDisabled}) => isDisabled && css`
    opacity: 0.5;
    pointer-events: none;
  `}
`;
export const TicketsCardHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TicketsCardName = styled.div`
    font-style: normal;
    font-weight: var(--general-large-body-font-weight);
    font-size: var(--general-large-body-font-size);
    line-height: 25px;
    color: var(--font-color-gray212529);
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const TicketsCardNameForMemberOnly = styled.div`
  font-style: normal;
  font-weight: var(--general-caption-font-weight);
  font-size: var(--general-caption-font-size);
  line-height: 25px;
  color: var(--font-color-gray212529);
`;

export const TicketsCardQuantity = styled.div``;
export const TicketsCardPrice = styled.div`
   font-style: normal;
    font-weight: var(--general-amount-font-weight);
    font-size: var(--general-amount-font-size);
    line-height: 25px;
    color: var(--font-color-gray212529);
`;

export const TicketRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #E8EAF0;
  background: #fff;
  gap: 10px;
  opacity: ${({ isDisabled }) => isDisabled ? 0.5 : 1};
  pointer-events: ${({ isDisabled }) => isDisabled ? 'none' : 'auto'};
`;

export const TicketRowLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const TicketRowName = styled.div`
  font-size: var(--general-small-header-font-size);
  font-weight: var(--general-small-header-font-weight);
  color: var(--font-color-blue002e5c);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--general-small-header-font-family);
`;

export const TicketRowPrice = styled.div`
  font-size: var(--general-caption-font-size);
  color: var(--font-color-slate64748b);
  font-weight: var(--general-caption-font-weight);
  font-family: var(--general-caption-font-family);
`;

export const SelectTicketsButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-radius: 8px;
  border: 1.5px solid #2555EF;
  background: #fff;
  cursor: pointer;
  font-family: var(--general-font-family);
  transition: background 0.15s;
  &:hover {
    background: rgba(37, 85, 239, 0.04);
  }
`;

export const TicketsModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1300;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TicketsModalBox = styled.div`
  background: #fff;
  border-radius: 16px;
  width: 520px;
  max-width: 95vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0,0,0,0.18);
  overflow: hidden;
`;

export const TicketsModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #F0F1F5;
`;

export const TicketsModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 20px;
  overflow-y: auto;
  flex: 1;
  scrollbar-width: thin;
  scrollbar-color: rgba(37,85,239,0.25) transparent;
  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { background: rgba(37,85,239,0.25); border-radius: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
`;

export const TicketsModalFooter = styled.div`
  padding: 14px 20px;
  border-top: 1px solid #F0F1F5;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;